import { FunctionComponent } from 'preact';
import cn from 'classnames';
import { useIcons } from '../../hooks/useIcons';

export interface LiveIconProps {
  disabled?: boolean;
}

export const LiveBadge: FunctionComponent<LiveIconProps> = ({ disabled }) => {
  const { Bullet } = useIcons();

  return (
    <i
      className={cn('vgp-live-badge', { 'vgp-live-badge-disabled': disabled })}
    >
      <Bullet />
    </i>
  );
};
